import React, { useState, useMemo } from "react";

import { getStatusAction, getStatusActionForAdmin, getStatusLabel } from "../utils/dashboardStorage";
import "../styles.css"

function formatDate(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleString("tr-TR");
}

const StatusClassMap = {
  1: "Todo",
  2: "InProgress",
  3: "PendingReview",
  4: "Reject",
  5: "Approve",
  6: "HasError",
};
const TaskStatusColors = {
    1: "#3b82f6", // Todo - blue
    2: "#f59e0b", // InProgress - amber
    3: "#eab308", // PendingReview - yellow
    4: "#ef4444", // Reject - red
    5: "#22c55e", // Approve - green
    6: "#6b7280", // HasError - gray
  };

  const TaskStatusLabelsTr = {
    1: "Yapılacak",
    2: "Yapılıyor",
    3: "İnceleme Bekliyor",
    4: "Onaylanmadı",
    5: "Tamamlandı",
    6: "Hatalı",
  };

export function Dashboard({
  users,
  currentUser,
  records,
  stats = [],
  isLoading,
  onChangeUser,
  onEdit,
}) {
  const [achievementSearch, setAchievementSearch] = useState("");
  const [sortField, setSortField] = useState("date");
  const [statusFilter, setStatusFilter] = useState(null);
  const [sortDirection, setSortDirection] = useState("desc");
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const getSortArrow = (field) => {
    if (sortField !== field) return "";
    return sortDirection === "asc" ? " ▲" : " ▼";
  };

  const filteredRecords = useMemo(() => {
    let result = [...records];
  
    // AchievementId filter
    if (achievementSearch) {
      result = result.filter((r) =>
        String(r.AchievementId).includes(achievementSearch.trim())
      );
    }
  
    // ✅ STATUS FILTER
    if (statusFilter !== null) {
      result = result.filter((r) => r.status === statusFilter);
    }
  
    // sorting
    result.sort((a, b) => {
      let valueA;
      let valueB;
  
      if (sortField === "status") {
        valueA = a.status;
        valueB = b.status;
      }

      if (sortField === "achievementId") {
        valueA = a.AchievementId;
        valueB = b.AchievementId;
      }
      
      if (sortField === "createdDate") {
        valueA = new Date(a.createdDate).getTime();
        valueB = new Date(b.createdDate).getTime();
      }
  
      if (sortField === "date") {
        valueA = new Date(a.updatedAt).getTime();
        valueB = new Date(b.updatedAt).getTime();
      }
  
      if (sortDirection === "asc") {
        return valueA - valueB;
      } else {
        return valueB - valueA;
      }
    });
  
    return result;
  }, [records, achievementSearch, sortField, sortDirection, statusFilter]);
  
//   const filteredRecords = useMemo(() => {
//     let result = [...records];

//     // AchievementId filter
//     if (achievementSearch) {
//       result = result.filter((r) =>
//         String(r.AchievementId).includes(achievementSearch.trim())
//       );
//     }

//     // sorting
//     result.sort((a, b) => {
//       let valueA;
//       let valueB;

//       if (sortField === "status") {
//         valueA = a.status;
//         valueB = b.status;
//       }

//       if (sortField === "date") {
//         valueA = new Date(a.updatedAt).getTime();
//         valueB = new Date(b.updatedAt).getTime();
//       }

//       if (sortDirection === "asc") {
//         return valueA - valueB;
//       } else {
//         return valueB - valueA;
//       }
//     });

//     return result;
//   }, [records, achievementSearch, sortField, sortDirection]);

  // const filteredRecords = useMemo(() => {
  //     if (!achievementSearch) return records;

  //     return records.filter((r) =>
  //       String(r.AchievementId).includes(achievementSearch.trim())
  //     );
  //   }, [records, achievementSearch]);

  return (
    <div className="video-builder-scope">
      <div className="layout">
        <section className="card">
          <div className="dashboard-head">
            <div>
              <h1>Video Paneli</h1>
              <p className="muted">
                {currentUser.role === "admin"
                  ? "Admin tüm etkileşimli videoları görür."
                  : "Öğretmen sadece kendi videolarını görür."}
              </p>
            </div>

            <div className="dashboard-user-panel">
              <div className="dashboard-user-panel">
                <label>
                  Kazanım ID Ara
                  <input
                    type="text"
                    placeholder="Kazanım ID giriniz..."
                    value={achievementSearch}
                    onChange={(e) => setAchievementSearch(e.target.value)}
                  />
                </label>
              </div>

              <div className="dashboard-user-meta">
                {/* <div>
                  <span className="muted">Öğretmen ID</span>
                  <strong>{currentUser.id}</strong>
                </div> */}

                <div>
                  <span className="muted">Ders</span>
                  <strong>{currentUser.lesson}</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="card">
          <div className="dashboard-list-head">
            <h2>Etkileşimli Videolar</h2>
          </div>

          {stats.length > 0 && (
  <div
    style={{
      display: "flex",
      gap: 12,
      marginBottom: 16,
      flexWrap: "wrap"
    }}
  >
    {stats.map((item) => {
      const isActive = statusFilter === item.VideoInteractionStatus;

      return (
        <div
          key={item.VideoInteractionStatus}
          onClick={() =>
            setStatusFilter((prev) =>
              prev === item.VideoInteractionStatus
                ? null
                : item.VideoInteractionStatus
            )
          }
          style={{
            background: isActive ? "#e5e7eb" : "#f3f4f6",
            padding: "8px 12px",
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontWeight: 600,
            cursor: "pointer",
            border: isActive
              ? `2px solid ${TaskStatusColors[item.VideoInteractionStatus]}`
              : "2px solid transparent"
          }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background:
                TaskStatusColors[item.VideoInteractionStatus] || "#999"
            }}
          />
          <span>
            {TaskStatusLabelsTr[item.VideoInteractionStatus]}: {item.Count}
          </span>
        </div>
      );
    })}
  </div>
)}



          {isLoading ? (
            <p className="muted">Video listesi yükleniyor...</p>
          ) : filteredRecords.length === 0 ? (
            <p className="muted">Bu kullanıcı için video bulunamadı.</p>
          ) : (
            <div className="dashboard-table-wrap">
              <table className="dashboard-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th
  style={{ cursor: "pointer" }}
  onClick={() => handleSort("achievementId")}
>
  KazanımId{getSortArrow("achievementId")}
</th>
                    <th>Video Adı</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("status")}
                    >
                      Durum{getSortArrow("status")}
                    </th>
                    <th
  style={{ cursor: "pointer" }}
  onClick={() => handleSort("createdDate")}
>
  Ekleniş Tarihi{getSortArrow("createdDate")}
</th>

                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("date")}
                    >
                      Son Güncelleme{getSortArrow("date")}
                    </th>
                    {currentUser.role === "admin" && <th>Öğretmen</th>}
                    <th />
                  </tr>
                </thead>

                <tbody>
                  {filteredRecords.map((record) => {
                    const action = getStatusAction(
                      StatusClassMap[record.status]
                    );

                    const adminActions = getStatusActionForAdmin(
                        StatusClassMap[record.status]
                    )
                    return (
                      <tr
                        key={record.id}
                        className={action.disabled ? "is-disabled" : ""}
                      >
                        <td>{record.id}</td>
                        <td>{record.AchievementId}</td>

                        <td>
                          <div className="dashboard-video-title">
                            {record.title}
                          </div>
                          <div className="muted">{record.lesson}</div>
                        </td>

                        <td>
                          <span
                            className={`status-pill status-${StatusClassMap[
                              record.status
                            ].toLowerCase()}`}
                          >
                            {getStatusLabel(StatusClassMap[record.status])}
                          </span>
                        </td>
                        <td>{formatDate(record.createdDate)}</td>

                        <td>{formatDate(record.updatedAt)}</td>

                        {currentUser.role === "admin" && (
                          <td>{record.ownerName}</td>
                        )}

                        {currentUser.role === "admin"  ?
                        <td>
                          <button
                            disabled={adminActions.disabled}
                            onClick={(event) => {
                              event.stopPropagation();

                              if (!adminActions.disabled) {
                                onEdit(record.id);
                              }
                            }}
                          >
                            {adminActions.label}
                          </button>
                        </td>
                        :
                        <td>
                          <button
                            disabled={action.disabled}
                            onClick={(event) => {
                              event.stopPropagation();

                              if (!action.disabled) {
                                onEdit(record.id);
                              }
                            }}
                          >
                            {action.label}
                          </button>
                        </td>}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
